import React from "react";
import "../styles/LandingPage.css";
import Header from "../components/Header"; // full-width header
import { useNavigate } from "react-router-dom";

const LandingPage: React.FC = () => {
  const navigate = useNavigate(); // hook from react-router-dom

  return (
    <>
      <Header /> {/* Header outside the container */}

      <div className="portal-container">
        {/* Hero Section */}
        <section className="portal-hero">
          <h1>Digital Services Portal</h1>
          <h3>
            European Once Only Technical System (DOTS) Single Digital Gateway
            Simulator
          </h3>
          <p>
            Streamlined cross-border digital services and document exchange
            across EU member states.
          </p>
        </section>

        {/* Features Section */}
        <section className="portal-features">
          <div className="feature-card blue">
            <div className="feature-icon">🛡️</div>
            <h4>Secure Registration</h4>
            <p>Centralised citizen portal for verified authentication.</p>
          </div>
          <div className="feature-card blue">
            <div className="feature-icon">🌍</div>
            <h4>Cross Border</h4>
            <p>Full interoperability across different EU member states.</p>
          </div>
          <div className="feature-card green">
            <div className="feature-icon">🏛️</div>
            <h4>Government Services</h4>
            <p>Simplified banking and government services access.</p>
          </div>
        </section>

        {/* Simulation Scenarios */}
        <section className="portal-scenarios">
          <h2>Available Simulation Scenarios</h2>
          <p>Choose a scenario to begin your DOTS simulation experience.</p>

          <div className="scenario-grid">
            {/* University Simulation */}
            <div className="scenario-card">
              <div className="scenario-icon">🎓</div>
              <h3>University Application</h3>
              <p>
                Simulate academic course application process requiring
                electronic level certificate
              </p>
              <ul>
                <li>Academic credential verification requests</li>
                <li>Electronic certificate provision</li>
                <li>Secure Response Portal Integration</li>
                <li>Cross-border document exchange</li>
              </ul>
              <button
                className="btn"
                onClick={() => navigate("/universities")}
              >
                Start University Simulation
              </button>
            </div>

            {/* Banking Simulation */}
            <div className="scenario-card">
              <div className="scenario-icon">🏦</div>
              <h3>Banking Services</h3>
              <p>
                Simulate cross-border banking services with address proof
                verification
              </p>
              <ul>
                <li>Cross-border bank account opening</li>
                <li>Address proof verification</li>
                <li>Identity document validation</li>
                <li>Online form</li>
              </ul>
              <button className="btn">Start Banking Simulation</button>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default LandingPage;
